<cc-top-bar [title]="'CALL_HISTORY.LABEL'" >
</cc-top-bar>
<router-outlet></router-outlet>
